import { SURVEY_API_BASE } from '../../api/constants';

/**
 * The API base URL for submitting survey responses.
 */
export const SUBMIT_BASE_URL = `${SURVEY_API_BASE}/responseV2`;
